<template>

  <div class="comment-add">
    <!-- 标题 -->
    <el-dialog :title="title" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"  :close-on-press-escape="false">
      <el-form size="small" :model="form" ref="form">
        <el-form-item label="类型" :label-width="formLabelWidth" prop="type" :rules="[{required: true,message: '请输入'}]">
          <el-select v-model="form.type" placeholder="请选择" clearable>
            <el-option label="不限" value=""></el-option>
            <el-option v-for="(v, i) in typeArr" :key="i" :label="v.name" :value="v.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="标题" :label-width="formLabelWidth" prop="title" :rules="[{required: true,message: '请输入'}]">
          <el-input v-model="form.title" placeholder="请输入" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="简介" :label-width="formLabelWidth" prop="intro" :rules="[{required: true,message: '请输入'}]">
          <el-input type="textarea" :rows="5" v-model="form.intro" autocomplete="off" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="积分描述" :label-width="formLabelWidth" prop="point_text" :rules="[{required: true,message: '请输入'}]">
          <el-input v-model="form.point_text" placeholder="请输入" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="积分" :label-width="formLabelWidth" prop="point" :rules="[{required: true,message: '请输入'}]">
          <el-input v-model="form.point" type="number" placeholder="请输入" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="图标" prop="icon_id" :label-width="formLabelWidth">
          <div class="img-item">
            <div class="addimg-select" @click="openUpload(1000)" v-if="!form.icon"><i class="el-icon-plus"></i></div>
            <el-image class="imgw100" v-else :src="form.icon" fit="cover" alt="" :preview-src-list="[form.icon]" />
            <a v-if="form.icon" href="javascript:void(0);" class="delete-btn" @click.stop="delImg"><i class="el-icon-close"></i></a>
          </div>
          <p class="gray9">建议尺寸150x150px</p>
        </el-form-item>

        <el-form-item label="弹窗" prop="is_popup" :label-width="formLabelWidth">
          <el-radio-group v-model="form.is_popup">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="状态" prop="status" :label-width="formLabelWidth">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible">取 消</el-button>
        <el-button  type="primary" @click="save" :loading="loading">确 定</el-button>
      </div>

    </el-dialog>

    <!--上传图片组件-->
    <Upload v-if="is_upload" :isupload="is_upload" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
  import PointsCateApi from '@/api/study/points_cate.js';
  import Upload from '@/components/file/Upload';
  export default {
    components: {
      Upload
    },
    data() {
      return {
        // 类型
        type:'add',  // add:添加  edit:编辑 dateil:详情
        title:'添加',

        //需要提交的表单
        form: {
          type: '',
          cate_id: '',
          icon: [],
          icon_id: '',
        },
        typeArr: [],
        
        /*左边长度*/
        formLabelWidth: '100px',
        /*是否显示*/
        dialogVisible: false,//是否展示
        //加载
        loading: false,
        /*是否上传图片*/
        is_upload: false,
        img_index: '',
      };
    },
    props: ['is_open', 'oneform', 'pointsType'],//open_add 是否展示
    created() {
      //数据赋值
      this.type = this.oneform.type;
      // 类型整理
      for (const i in this.pointsType) {
        this.typeArr.push({name:this.pointsType[i], value: parseInt(i)});
      }

      //类型
      if(this.type == 'edit' || this.type == 'dateil'){

        if(this.type == 'edit' ){
          this.title = '编辑';
        }else{
          this.title = '详情';
        }
        //赋值
        this.form = this.oneform.model;
        if (!this.form.cate_id) this.form.cate_id = '';
      }

      //是否展示
      this.dialogVisible = this.is_open;
    },
    methods: {
      /*保存*/
      save() {
        let self = this;
        let params = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            if(self.type == 'add'){
              PointsCateApi.add(params).then(data => {
                self.loading = false;
                self.$message({
                  message: '添加成功',
                  type: 'success'
                });
                self.dialogFormVisible(true);
              }).catch(error => {
                self.loading = false;
              });
            }else if(self.type == 'edit'){
              PointsCateApi.edit(params).then(data => {
                self.loading = false;
                self.$message({
                  message: '添加成功',
                  type: 'success'
                });
                self.dialogFormVisible(true);
              }).catch(error => {
                self.loading = false;
              });
            }
          }
        })
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },

      /*上传*/
      openUpload(e) {
        this.img_index = e;
        this.is_upload = true;
      },

      delImg(){
        this.form.icon = '';
        this.form.icon_id = '';
      },

      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null) {
          if (this.img_index == 1000){
            this.form.icon = e[0].file_path;
            this.form.icon_id = e[0].file_id;
          }else{
            this.customField[this.img_index].image = e[0].file_path;
            this.customField[this.img_index].image_id = e[0].file_id;
          }
        }
        this.is_upload = false;
      },

    }
  };
</script>




// WEBPACK FOOTER //
// src/views/user/points/part/part/Add.vue